import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Dialog } from '@material-ui/core';

import { RESTAURANT_STATUS_UNKNOWN } from 'src/StateMachines/STATES';
import { LYNKED_WHITE, LYNKED_GREEN } from 'src/consts/colors';
import { getNewUserLineupLink } from 'src/utils/getLinks';

import active_lang from 'src/langs/jp_en';
import { MenyContext } from '../../../contexts';
import { useTranslation } from 'react-i18next';

export default function SorryRestaurantClosedSign({ open, setOpen }) {
  let navigate = useNavigate();
  const { t } = useTranslation();

  let { rest_id, menu_id, setOpenAdsFoodDetailDialog, setOpenMenyLightAdsFoodDetailDialog, meny_client_state_machine } =
    React.useContext(MenyContext);
  let [client_state, sendClientState] = meny_client_state_machine;

  const handleCloseOnClick = () => {
    sendClientState(RESTAURANT_STATUS_UNKNOWN);
    navigate(getNewUserLineupLink(rest_id, menu_id), { replace: true });

    setOpen(false);
  };

  React.useEffect(() => {
    if (open) {
      // setOpenAdsFoodDetailDialog(false);
      setOpenMenyLightAdsFoodDetailDialog(false);
    }
  }, [open]);

  return (
    <>
      <Dialog
        id="sorry_restaurant_closed_sign"
        open={open}
        style={{ height: '100%' }}
        BackdropProps={{
          style: {
            background: 'rgba( 0, 0, 0, 0.15 )',
            boxShadow: '0 8px 32px 0 rgba( 31, 38, 135, 0.37 )',
            backdropFilter: 'blur( 4px )',
            borderRadius: '10px',
            border: '1px solid rgba( 255, 255, 255, 0.18 )',
          },
        }}
        transitionDuration={{ enter: 0, exit: 0 }}
      >
        <Box
          style={{
            height: '100%',
            display: 'flex',
            flexFlow: 'column',
            background: '#ACACAC 0% 0% no-repeat padding-box',

            justifyContent: 'center',
            alignItems: 'center',

            overflowX: 'hidden',
          }}
          id={'sorry_restaurant_closed_sign'}
        >
          <Box
            style={{
              width: '90vw',
              height: '250px',
              backgroundColor: LYNKED_WHITE,

              display: 'flex',
              flexFlow: 'column',
              justifyContent: 'space-between',
            }}
          >
            <Box
              style={{
                paddingTop: '2rem',
                paddingBottom: '1rem',

                width: '100%',
                textAlign: 'center',

                display: 'flex',
                flexFlow: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Box style={{ width: '80%', textAlign: 'center' }}>
                {/* {active_lang.SORRY_BUT_WE_RE_CLOSED} */}
                <Box pb={'1rem'}>{t('OTHERS_CLOSE_STORE_MSG')}</Box>
                <Box pb={'1rem'}>{t('OTHERS_WELCOME_BACK_MSG')}</Box>
              </Box>
            </Box>

            <Box style={{ width: '100%' }}>
              <Button
                id="ack-restaurant-closed"
                fullWidth
                style={{
                  height: '50px',
                  color: LYNKED_WHITE,
                  backgroundColor: LYNKED_GREEN,
                  // background: '#388E00 0% 0% no-repeat padding-box',
                  borderRadius: 'unset',
                  fontWeight: 'bold',
                }}
                onClick={handleCloseOnClick}
              >
                {t('LINEUP_OK')}
              </Button>
            </Box>
          </Box>
        </Box>
      </Dialog>
    </>
  );
}
